// libs
import { useParams } from 'react-router'

// interfaces
import { ProfilesListProfileType } from 'src/interfaces/profile'
import { ProfilesListURI } from 'src/interfaces/profiles_list'

// helpers
import { UrlUtils } from 'src/utils/url/url'

interface RouteParams {
  category?: string;
}

export const useAuthorTypeFromURL = (): ProfilesListProfileType | undefined => {
  const { category } = useParams<RouteParams>()

  if (!category) {
    return
  }

  return UrlUtils.mapUrlParamToAuthorType(category as ProfilesListURI)
}
